var map = {
	"./be-fr.json": "d735",
	"./ch-de.json": "4eaa",
	"./ch-fr.json": "e963",
	"./de.json": "bac1",
	"./dk.json": "302a",
	"./en.json": "e312",
	"./es.json": "ef523",
	"./fi.json": "bf68",
	"./fl.json": "6881",
	"./fr.json": "b16e",
	"./it.json": "669f",
	"./lu-de.json": "6b9a",
	"./lu-fr.json": "b33f",
	"./nl.json": "b94d",
	"./no.json": "59df",
	"./se.json": "be3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a35b";